// @flow
import React from 'react';
import PropTypes from "prop-types";

import _ from 'underscore';

// import Konva from 'konva';
import {Stage, Layer, Line, Circle, Text} from 'react-konva';

const propTypes = {
	// ProductInfo objekt:
	product: PropTypes.object,
	// Pildi laius
	width: PropTypes.number,
	// Pildi kõrgus
	height: PropTypes.number,
	
	// Abijoonte värvus
	lineColor: PropTypes.any,
	// Abijoonte paksus
	lineStrokeWidth: PropTypes.number,
	// Klaasi joone värvus
	glassColor: PropTypes.any,
	// Klaasi joone paksus
	glassStrokeWidth: PropTypes.number,
	// E-punktide värvus
	ePointColor: PropTypes.any,
	// P-punktide värvus
	pPointColor: PropTypes.any,
    // HUD punktide värvus
    hudPointColor: PropTypes.any,
	// Punktide ringjoone paksus
	pointStrokeWidth: PropTypes.number,
	// Punktide fondi suurus
	pointFontSize: PropTypes.number,
	// Punktide raadius
	pointRadius: PropTypes.number,
	// Punktide teksti font
	pointFont: PropTypes.string
	
};

const defaultProps = {
	lineColor: 'rgb(150,150,150)',
	lineStrokeWidth: 1,
	glassColor: 'rgb(0,0,0)',
	glassStrokeWidth: 2,
	ePointColor: 'rgb(255,0,0)',
	pPointColor: 'rgb(0,0,255)',
    hudPointColor: 'rgb(0,255,255)',
	textColor: 'rgb(150,150,150)',
	pointStrokeWidth: 1,
	pointFontSize: 12,
	pointFont: 'Calibri',
	pointRadius: 5
};

class GlassImage extends React.Component {
	renderProduct() {
        /**
         * @type {ProductInfo}
         */
		let pr = this.props.product;
		if (!pr || !pr.glass) return [];
		let ncp = pr.glass;
		if (!ncp.tahvelx) return [];
		
		let modx = this.props.width / ncp.tahvelx;
		let mody = this.props.height / ncp.tahvely;
		if (mody < modx) modx = mody;

		let height = Math.round(ncp.tahvely*modx);
		//let width = Math.round(ncp.tahvelx*modx);
		let ph = height - Math.round(modx);
		let jminx = Math.round(ncp.minx*modx);
		let jminy = Math.round(ncp.miny*modx);
		let jmaxx = Math.round(ncp.maxx*modx);
		let jmaxy = Math.round(ncp.maxy*modx);

		let offsetx = Math.round((this.props.width - (jmaxx - jminx)) / 2);
		let offsety = Math.round((this.props.height - (jmaxy - jminy)) / 2);

		let el = [];
		
		// Kast:
		let points = [
			offsetx + jminx, offsety + ph - jminy,
			offsetx + jminx, offsety + ph - jmaxy,
			offsetx + jmaxx, offsety + ph - jmaxy,
			offsetx + jmaxx, offsety + ph - jminy,
			offsetx + jminx, offsety + ph - jminy
		];
		el.push(<Line key='rect' points={points} stroke={this.props.lineColor} strokeWidth={this.props.lineStrokeWidth}/>);

		// Ristjoon:
		points = [
			offsetx + jminx, offsety + ph - Math.round(ncp.kesky*modx),
			offsetx + jmaxx, offsety + ph-Math.round(ncp.kesky*modx)
		];
		el.push(<Line key='mid' points={points} stroke={this.props.lineColor} strokeWidth={this.props.lineStrokeWidth}/>);

		// Mõõtejoonte asukohtadele vastavad püstjooned:
		for (let i = 0; i < pr.lineCount; i++) {
			points = [
				offsetx + Math.round((pr.joona[i] + ncp.keskx)*modx), offsety + ph-jminy,
				offsetx + Math.round((pr.joony[i] + ncp.keskx)*modx), offsety + ph - jmaxy
			];
			el.push(<Line key={'hline_'+i.toString()} points={points} stroke={this.props.lineColor} strokeWidth={this.props.lineStrokeWidth}/>);
		}
		
		// Klaasi kontuur:
		for (let i = 0; i < ncp.ridu; i++) {
			points = [
				offsetx + Math.round((ncp.joonx1[i] + ncp.keskx)*modx),
				offsety + ph - Math.round((ncp.joony1[i] + ncp.kesky)*modx),
				offsetx + Math.round((ncp.joonx2[i] + ncp.keskx)*modx),
				offsety + ph - Math.round((ncp.joony2[i] + ncp.kesky)*modx)
			];
			el.push(<Line key={'glass_'+i} points={points} stroke={this.props.glassColor} strokeWidth={this.props.glassStrokeWidth}/>);
		}
		
		// E-punktid ja kõrgused (H=) (vt rida 4635):
		for (let i = 0; i < pr.lineCount*2; i++) {
			// Punkt ise
			let abiX = offsetx + Math.round((pr.ex[i] + ncp.keskx)*modx);
			let abiY = offsety + ph - Math.round((pr.ey[i]+ncp.kesky)*modx);
			el.push(<Circle key={'e_'+i} x={abiX} y={abiY} radius={this.props.pointRadius} stroke={this.props.ePointColor} strokeWidth={this.props.pointStrokeWidth}/>);
			
			// Punkti juures kuvatav tekst
			// TODO: Vaja leida õiged offsetid
			abiX += this.props.pointRadius + 2;
			if (i % 2 == 0) abiY += this.props.pointRadius + 2;
			else abiY -= (this.props.pointRadius + 2) + 10;
			el.push(<Text key={'en_'+i} x={abiX} y={abiY} text={'E'+(i+1).toString()} fontSize={this.props.pointFontSize} fontFamily={this.props.pointFont} fill={this.props.textColor}/>);
			
			// Punkti kõrgus "H="
			// TODO: Vaja leida õiged offsetid
			if (i % 2 == 0) abiY += 15;
			else abiY -= 15;
			el.push(<Text key={'h_'+i} x={abiX} y={abiY} text={'H='+(pr.ez[i] ? pr.ez[i].toString() : '')} fontSize={this.props.pointFontSize} fontFamily={this.props.pointFont} fill={this.props.textColor}/>);
		}

		// P-punktid:
		for (let i = 0; i < pr.pNimi.length; i++) {
			if (pr.px == null || pr.py == null || !pr.pOlemas[i]) continue;

			// Punkt ise
			let abiX = offsetx + Math.round((pr.px[i] + ncp.keskx)*modx);
			let abiY = offsety + ph - Math.round((pr.py[i]+ncp.kesky)*modx);
			el.push(<Circle key={'p_'+i} x={abiX} y={abiY} radius={this.props.pointRadius} stroke={this.props.pPointColor} strokeWidth={this.props.pointStrokeWidth}/>);
			
			// Punkti juures kuvatav tekst
			// TODO: Vaja leida õiged offsetid
			if (i < pr.lineCount*3) abiX += this.props.pointRadius + 2;
			else abiX -= this.props.pointRadius + 22;
			if (i % 3 == 0 && i < pr.lineCount*3) abiY += this.props.pointRadius + 2;
			else abiY -= (this.props.pointRadius + 2) + 10;
			el.push(<Text key={'pn_'+i} x={abiX} y={abiY} text={pr.pNimi[i]} fontSize={this.props.pointFontSize} fontFamily={this.props.pointFont} fill={this.props.textColor}/>);
		}

        // HUD punktid:
        for (let i = 0; i < pr.hudPoints; i++) {
            if (pr.hudx == null || pr.hudy == null || pr.hudx.length <= i || pr.hudy.length <= i) break;

            // Punkt ise
            let abiX = offsetx + Math.round((pr.hudx[i] + ncp.keskx)*modx);
            let abiY = offsety + ph - Math.round((pr.hudy[i]+ncp.kesky)*modx);
            el.push(<Circle key={'hud_'+i} x={abiX} y={abiY} radius={this.props.pointRadius} stroke={this.props.hudPointColor} strokeWidth={this.props.pointStrokeWidth}/>);

            // Punkti juures kuvatav tekst
            // TODO: Vaja leida õiged offsetid
            //if (i < pr.lineCount*3) abiX += this.props.pointRadius + 2;
            //else
            abiX -= this.props.pointRadius + 40;
            // if (i % 3 == 0 && i < pr.lineCount*3) abiY += this.props.pointRadius + 2;
            // else
            abiY -= Math.round(this.props.pointRadius / 2);
            el.push(<Text key={'hudn_'+i} x={abiX} y={abiY} text={"HUD" + (i+1)} fontSize={this.props.pointFontSize} fontFamily={this.props.pointFont} fill={this.props.textColor}/>);
        }

        // S-punktid (trükiserv):
		for (let i = 0; i < pr.lineCount*2; i++) {
			if (pr.s.length <= i || !_.isNumber(pr.s[i]) || pr.s[i] === 0) continue;
			let base = Math.floor(i / 2) * 2;
			let v = pr.s[i] / Math.sqrt(Math.pow(pr.ex[base+1] - pr.ex[base], 2) + Math.pow(pr.ey[base+1] - pr.ey[base], 2));
			let tx = pr.ex[base+1] - ((pr.ex[base+1] - pr.ex[base])*v);
			let ty = pr.ey[base+1] - ((pr.ey[base+1] - pr.ey[base])*v);
			
			let abiX = offsetx + Math.round((tx + ncp.keskx)*modx) + 10;
			let abiY = offsety + ph - Math.round((ty + ncp.kesky)*modx);
			points = [
				offsetx + Math.round((tx + ncp.keskx)*modx) - 10,
				offsety + ph - Math.round((ty + ncp.kesky)*modx),
				abiX,
				abiY
			];
			el.push(<Line key={'s_'+i} points={points} stroke={this.props.lineColor} strokeWidth={this.props.lineStrokeWidth}/>);
			abiX -= 5;
			abiY -= 10;
			el.push(<Text key={'sn_'+i} x={abiX} y={abiY} text={'S'+(i+1).toString()} fontSize={this.props.pointFontSize} fontFamily={this.props.pointFont} fill={this.props.textColor}/>);
		}
		
		// Kui on nihutatud, siis nihke asukoht:
		if (pr.xnihe != 0 || pr.ynihe != 0) {
			let aax = -pr.xnihe;
			let aay = -pr.ynihe;
			// Väike rasvane rist 45 kraadi all:
			points = [
				offsetx + Math.round((aax + ncp.keskx)*modx) - 5,
				offsety + ph - Math.round((aay + ncp.kesky)*modx) - 5,
				offsetx + Math.round((aax + ncp.keskx)*modx) + 5,
				offsety + ph - Math.round((aay + ncp.kesky)*modx) + 5
			];
			el.push(<Line key='r_1' points={points} stroke={this.props.lineColor} strokeWidth={this.props.glassStrokeWidth}/>);
			points = [
				offsetx + Math.round((aax + ncp.keskx)*modx) - 5,
				offsety + ph - Math.round((aay + ncp.kesky)*modx) + 5,
				offsetx + Math.round((aax + ncp.keskx)*modx) + 5,
				offsety + ph - Math.round((aay + ncp.kesky)*modx) - 5
			];
			el.push(<Line key='r_2' points={points} stroke={this.props.lineColor} strokeWidth={this.props.glassStrokeWidth}/>);
			
			// Suur peenikeste joontega rist:
			points = [
				offsetx + Math.round((aax + ncp.keskx)*modx) - 20,
				offsety + ph - Math.round((aay + ncp.kesky)*modx),
				offsetx + Math.round((aax + ncp.keskx)*modx) + 20,
				offsety + ph - Math.round((aay + ncp.kesky)*modx)
			];
			el.push(<Line key='r_3' points={points} stroke={this.props.lineColor} strokeWidth={this.props.lineStrokeWidth}/>);
			points = [
				offsetx + Math.round((aax + ncp.keskx)*modx),
				offsety + ph - Math.round((aay + ncp.kesky)*modx) - 20,
				offsetx + Math.round((aax + ncp.keskx)*modx),
				offsety + ph - Math.round((aay + ncp.kesky)*modx) + 20
			];
			el.push(<Line key='r_4' points={points} stroke={this.props.lineColor} strokeWidth={this.props.lineStrokeWidth}/>);
		}
		
		return el;
	}
	
	render() {
		let elements = this.renderProduct();
		return (
			<Stage width={this.props.width} height={this.props.height}>
				<Layer>
					{elements}
				</Layer>
			</Stage>
		);
	}
}

GlassImage.propTypes = propTypes;
GlassImage.defaultProps = defaultProps;

export default GlassImage;
